module.exports = __webpack_public_path__ + "img/Mardona-6.dc2e80e5.webp";